import React from 'react';
import {useNavigate, Link} from 'react-router-dom';
import {FormularioLoginStandar} from '../../components/login/FormularioLoginStandar';
import {LoginExterno} from '../../components/login/LoginExterno';

/* A function that returns a JSX element. */
export const ContentBodyLogiInterno = (props) => {
	/* Returning a JSX element. */
	return (
		<div className='contentbodyLoginInterno'>
			<FormularioLoginStandar />
		</div>
	);
};
/*

            <FormularioLoginStandar />
            <div className='enlazesLogin'>
                <div className='linkFormLogin'>
                    <div onClick={() => navigate('/olvidarContrasena')}><b>¿Has olvidado la contraseña?</b></div>
                </div>
                <div className='linkFormLogin'>
                    <div onClick={() => navigate('/registro')}>Si no tiene cuenta, <b>regístrese aquí.</b></div>
                </div>

            </div>
            <div className='separadorContentBodyLoginInterno'>
                <div className='centrador'> <div className='barraSeparadorContentBodyLoginInterno'> </div> </div>
                <div>ó</div>
                <div className='centrador'> <div className='barraSeparadorContentBodyLoginInterno'> </div> </div>
            </div>
            <LoginExterno />

*/
